<div mat-dialog-content>
  <form [formGroup]="formRecipe">
    <div class="grid-container">
      <div class="grid-item">
        <mat-form-field class="form-field-fixed-l">
          <mat-label>{{ 'TITLE' | translate }}</mat-label>
          <input
            id="RecipesModifyTitleModifyTxt"
            #titleInput
            matInput
            formControlName="title"
            required
            (keydown.enter)="$event.preventDefault()"
            (ngModelChange)="bineratorLenghtTest('title')"
            (blur)="bineratorLenghtTestOnFocus('title'); onBlur()"
            (focus)="onFocus()"
          />
          <mat-error *ngIf="formRecipe.controls.title.hasError('required')">
            {{ 'TITLE_REQUIRED' | translate }}
          </mat-error>
          <mat-error *ngIf="formRecipe.controls.title.hasError('binerator')">
            {{ 'BINERATOR.RULES.TITLE.TOO_LONG' | translate }}
          </mat-error>
        </mat-form-field>
      </div>
      <div class="grid-item">
        <button
          *ngIf="isEditSoftHyphenAllowed$ | async"
          mat-mini-fab
          class="btn-submit"
          title="inserer soft hyphen"
          (click)="addSoftHyphen()"
          [disabled]="isButtonDisabled"
        >
          <mat-icon>keyboard_return</mat-icon>
        </button>
      </div>
      <div class="grid-item">
        <mat-form-field class="form-field-fixed-l">
          <mat-label>{{ 'SUBTITLE' | translate }}</mat-label>
          <input
            id="RecipesModifyShortTitleModifyTxt"
            matInput
            formControlName="shortTitle"
            (ngModelChange)="bineratorLenghtTest('shortTitle')"
            (blur)="bineratorLenghtTestOnFocus('shortTitle')"
          />
          <mat-error *ngIf="formRecipe.controls.shortTitle.hasError('required')">
            {{ 'SUBTITLE_REQUIRED' | translate }}
          </mat-error>
          <mat-error *ngIf="formRecipe.controls.shortTitle.hasError('binerator')">
            {{ 'BINERATOR.RULES.SHORT_TITLE.TOO_LONG' | translate }}
          </mat-error>
        </mat-form-field>
      </div>
    </div>
  </form>
</div>
<div mat-dialog-actions>
  <button class="space-h-s btn-warn" id="RecipesModifyTitleModifyCancelBtn" mat-raised-button (click)="cancel()">
    {{ 'CANCEL' | translate }}
  </button>
  <button
    class="space-h-s btn-submit"
    id="RecipesModifyTitleModifySaveBtn"
    mat-raised-button
    (click)="submitSelection()"
    [disabled]="formRecipe.invalid"
  >
    {{ 'SAVE' | translate }}
  </button>
</div>
